(function (ng, $) {
    //Directive that manages the "PDPDP" and its initialization methods that need to fire in order to
    //work correctly, particularaly with the matrix selectors

    var selectors = {
        BuyGrid: '#buy-grid',
        DisplayPanels: '.js-display-panel',
        IncompatibleMessage: 'Incompatible with Current Selection(s)',
        MarketingPrice: '#pdp-marketing-price',
        matrices: '.js-selection-matrix',
        MatrixOptions: '.js-selection-matrix-option',
        MatrixOptionContainer: '.js-selection-matrix-option-container',
        PdpdpDetails: '.accordion-group',
        PriceDisplay: '#price-display',
        HeroContainer: '.js-pdp-hero-container',
        ScrollToId: '.js-scrolltoid',
        SelectedItemId: '#pdpdp-selected-item-id',
        TextToTruncate: '.js-truncate-text'
    };

    //helper method that transforms a number to a currency-formatted string (US dollars only)
    function formatNumberToCurrency(num) {
        return numeral(num).format();
    }

    //helper method that creates the html needed for the price display in the buy grid
    function createPriceDisplay(minPrice, minPriceStatus, maxPrice, maxPriceStatus) {
        var elements = [];

        elements.push(createPriceSpan(minPrice, minPriceStatus, minPriceStatus !== maxPriceStatus || minPrice === maxPrice));
        if (minPrice < maxPrice) {
            //display a hyphen
            //if either of the prices are full-priced, the hyphen should be black, otherwise red
            elements.push($('<span></span>').addClass('pdp-price-' + (minPriceStatus === 1 || maxPriceStatus === 1 ? 'regular' : 'discount') + ' pdp-price-display').html(' - '));
            elements.push(createPriceSpan(maxPrice, maxPriceStatus, true));
        }

        return elements;
    }

    //helper method that creates the html needed for a price and its price status
    function createPriceSpan(price, priceStatus, includeStatus) {
        var priceClass = priceStatus === 1 ? 'regular' : 'discount',
            $priceSpan = $('<span></span>').addClass('pdp-price-' + priceClass + ' pdp-price-display no-wrap');

        $priceSpan.html(formatNumberToCurrency(price));

        if (includeStatus) {
            switch (priceStatus) {
                case 2:
                    $priceSpan.append(' Sale');
                    break;
                case 3:
                    $priceSpan.append(' Limited Time');
                    break;
                case 4:
                    $priceSpan.append(' Clearance');
                    break;
            }
        }

        return $priceSpan;
    }

    ng.module('evo.Packages.Directives').directive('productPage', [
        function () {
            return {
                link: function ($scope, $el) {
                    $scope.$watch('productPage', function (newVal) {
                        $el.html(newVal ? newVal.html : '');
                        if (newVal) {
                            //Init main hero interactions
                            ng.element(selectors.HeroContainer).heroInteraction();

                            //before initializing the matrix selectors,
                            //we need to disable any options that aren't compatible with
                            //items already selected
                            $el.find(selectors.MatrixOptions).each(function (idx, optionEl) {
                                var $option = $(optionEl),
                                    disableReason = null,
                                    existingItemIds = ($option.attr('data-itemids') || '').split(','),
                                    newItemIds = [];

                                ng.forEach(existingItemIds, function (itemId) {
                                    itemId = parseInt(itemId, 10);
                                    if (isNaN(itemId)) {
                                        return;
                                    }
                                    var item = itemInfo[itemId];
                                    if (!item) {
                                        return;
                                    }
                                    var removeItem = false;
                                    if (!(item.Availability & 1) || item.DisplayType !== 1) {
                                        removeItem = true;
                                        disableReason = disableReason || 'Unavailable Online';
                                    }
                                    else if (newVal.itemIds.indexOf(itemId) < 0) {
                                        removeItem = true;
                                        disableReason = disableReason || selectors.IncompatibleMessage;
                                    }

                                    if (removeItem) {
                                        $option.removeClass('_' + itemId);
                                    } else {
                                        newItemIds.push(itemId);
                                    }
                                });
                                if (!newItemIds.length) {
                                    $option.prop('disabled', true);
                                    $option.attr('data-itemids', '');
                                    $option.data('itemids', '');
                                    switch (disableReason) {
                                        case selectors.IncompatibleMessage:
                                            $option
                                                .closest(selectors.MatrixOptionContainer)
                                                .append('<div class="pdp-selection-error pdpdp-incompatible-error">' + selectors.IncompatibleMessage + '</div>')
                                                .on({
                                                    'mouseover': function () {
                                                        ng.element(this).addClass("show-incompatible-tooltip");
                                                    },
                                                    'mouseleave': function () {
                                                        ng.element(this).removeClass("show-incompatible-tooltip");
                                                    }
                                                })
                                                .find('.pdp-selection-text').attr('title', '');
                                            break;
                                        case null:
                                            break;
                                        default:
                                            $option.data('disable-reason', disableReason);
                                            break;
                                    }
                                } else {
                                    $option.attr('data-itemids', newItemIds);
                                    $option.data('itemids', newItemIds);
                                }
                            });

                            $el.matrixSelectors({
                                items: itemInfo,
                                selectionUpdated: function (result) {
                                    //update the page display
                                    $(selectors.PriceDisplay).html(createPriceDisplay(result.minPrice, result.minPriceStatus, result.maxPrice, result.maxPriceStatus));
                                    //if both the min and max prices are not full-priced, we need to show the original price
                                    if (result.minPriceStatus !== 1 && result.maxPriceStatus !== 1) {
                                        var origPriceDisplay = $('<span></span>').addClass('pdp-price-regular discount');
                                        origPriceDisplay.append(formatNumberToCurrency(result.minMarketingPrice));
                                        if (result.minMarketingPrice < result.maxMarketingPrice) {
                                            origPriceDisplay.append(' - ' + formatNumberToCurrency(result.maxMarketingPrice));
                                        }
                                        $(selectors.PriceDisplay).prepend(origPriceDisplay);
                                    }

                                    //in case we've isolated our selections down to one, update the hidden element needed for the form to post
                                    var isolatedItemId = result.itemIds.length === 1 ? result.itemIds[0] : '';
                                    $(selectors.SelectedItemId).val(isolatedItemId);

                                    //also if we're narrowed down, we need to update the sell out risk display
                                    if (isolatedItemId) {
                                        var displayPanelsToShow = '.sellout-risk-' + itemInfo[isolatedItemId].SelloutRisk,
                                            $displayPanels = $(selectors.DisplayPanels);
                                        $displayPanels.not(displayPanelsToShow).hide();
                                        $displayPanels.filter(displayPanelsToShow).show();
                                    }
                                }
                            });

                            //using the filtered item ids
                            //we can see if there are matrix options that we can select by default (assuming they're the only one that match unfiltered items)
                            var itemIdSelector = '._' + (newVal.filteredItemIds || []).join(',._');
                            $(selectors.matrices).each(function (index, matrixEl) {
                                var unFilteredOptions = $(matrixEl).find(selectors.MatrixOptions).filter(itemIdSelector);

                                if (unFilteredOptions.size() === 1) {
                                    unFilteredOptions.prop('checked', true).trigger('change');
                                }
                            });

                            //Truncate short description text
                            var textElement = ng.element(selectors.TextToTruncate),
                                textHeight = textElement.height(),
                                textLineHeight = parseInt(textElement.css('line-height').substring(0, 2)),
                                truncatedLineNumber = textElement.attr('data-lines'),
                                truncatedHeight = textLineHeight * truncatedLineNumber,
                                textElementParent = textElement.parent();

                            if (textHeight > truncatedHeight) {
                                textElement.height(truncatedHeight);

                                textElementParent.on('click', function () {
                                    textElement.height(textHeight);
                                    ng.element(this).addClass('expanded');
                                });
                            }

                            ng.element(selectors.PdpdpDetails).mobileAccordion({ desktopAccordion: true });
                            ng.element(selectors.ScrollToId).scrollToID({ offset: 0 });
                        }
                    });
                },
                replace: false,
                restrict: 'E',
                scope: {
                    productPage: '='
                }
            };
        }
    ]);
})(angular, jQuery);